"use client";

import { useEffect } from "react";
import { saveTimeZoneAction } from "@/app/(app)/shell-actions";
import { parseTimeZone } from "@/lib/ui/timezone";

type TimeZoneSyncProps = {
  saved: string;
};

export function TimeZoneSync({ saved }: TimeZoneSyncProps) {
  useEffect(() => {
    const zone = parseTimeZone(
      Intl.DateTimeFormat().resolvedOptions().timeZone,
    );
    if (!zone || zone === saved) {
      return;
    }
    void saveTimeZoneAction(zone);
  }, [saved]);

  return null;
}
